var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11,
  stroke: "currentColor",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.75 9.667H8V12h1.75v7h2.917v-7h2.124L15 9.667h-2.333v-.973c0-.557.112-.777.65-.777H15V5h-2.221C10.68 5 9.75 5.923 9.75 7.692z"
}))));
export default SvgFacebookIcon;